import { render } from "./FormTemplate.vue?vue&type=template&id=0a067c48&ts=true"
import script from "./FormTemplate.vue?vue&type=script&lang=ts"
export * from "./FormTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__